<script setup lang="ts">
import { storeToRefs, ref, watch, computed } from '#imports';

import { useArticlesStore } from '@/entities/Article/store';

import { getShareUrl } from './utils';
import valueFragile from '@/shared/utils/value-fragile';

import IconEmail from '@/assets/icons/icon-email.svg';
import IconVk from '@/assets/icons/icon-vk.svg';
import IconTelegram from '@/assets/icons/icon-telegram.svg';

const articlesStore = useArticlesStore();
const { openArticleId, articleById, isEmptyArticleId } = storeToRefs(articlesStore);

const openArticle = ref();

watch(openArticleId, (val) => {
	openArticle.value = articleById.value(
		valueFragile(val, 'dialog-action-quote, articleById, openArticleId'),
		'article',
	) || {};
}, { immediate: true });

const computedShareLink = computed(() => {
	return `${window.location.origin}/dictionary/${openArticle.value?.slug_path}`;
});

const computedLinkClass = computed(() => ({
	'share-list__link': true,
	'share-list__link--disabled': isEmptyArticleId.value,
}));

const computedArticleTitle = computed(() => openArticle.value?.name ?? '');
</script>

<template>
	<div class="share-list">
		<p class="share-list__title">
			Поделиться
		</p>

		<ul class="share-list__list">
			<li class="share-list__list-item">
				<a
					:class="computedLinkClass"
					:href="getShareUrl('mail', computedShareLink, { subject: computedArticleTitle })"
					target="_blank"
					rel="noopener"
				>
					<icon-email class="icon" />
				</a>
			</li>
			<li class="share-list__list-item">
				<a
					:class="computedLinkClass"
					:href="getShareUrl('vk', computedShareLink, { title: computedArticleTitle })"
					target="_blank"
					rel="noopener"
				>
					<icon-vk class="icon" />
				</a>
			</li>
			<li class="share-list__list-item">
				<a
					:class="computedLinkClass"
					:href="getShareUrl('telegram', computedShareLink, { text: `\n${computedArticleTitle}` })"
					target="_blank"
					rel="noopener"
				>
					<icon-telegram class="icon" />
				</a>
			</li>
		</ul>
	</div>
</template>

<style lang="scss" scoped>
.share-list {
	max-width: rem(100px);
	padding: rem($gap-mini);

	&__title {
		@include text-medium;
	}

	&__list {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		grid-auto-rows: 1fr;
		grid-gap: rem($gap-micro);

		margin-top: rem($gap-small);
	}

	&__link {
		color: blue;

		&--disabled {
			cursor: not-allowed;
			pointer-events: none;

			color: black;
		}
	}
}
</style>
